import { createSignal } from "solid-js";
import { accountIdForAlias } from "./account-alias";

export const TAB_ACCOUNT_STORAGE_KEY = "tab_account";
export const LAST_ACTIVE_ACCOUNT_KEY = "last_active_account";
export const TAB_ACCOUNT_CHANGED_EVENT = "custodia:tab-account-changed";
export const ACCOUNT_HANDOFF_PARAM = "as";

let initialParamConsumed = false;

function consumeInitialHandoffParam(): string | null {
  if (initialParamConsumed || globalThis.location === undefined) {
    return null;
  }
  initialParamConsumed = true;
  try {
    const url = new URL(globalThis.location.href);
    const alias = url.searchParams.get(ACCOUNT_HANDOFF_PARAM);
    if (!alias) {
      return null;
    }
    url.searchParams.delete(ACCOUNT_HANDOFF_PARAM);
    globalThis.history.replaceState(null, "", url.pathname + url.search + url.hash);
    return accountIdForAlias(alias);
  } catch {
    return null;
  }
}

export function readTabAccountId(): string | null {
  const fromHandoff = consumeInitialHandoffParam();
  if (fromHandoff) {
    try {
      globalThis.sessionStorage.setItem(TAB_ACCOUNT_STORAGE_KEY, fromHandoff);
      globalThis.localStorage.setItem(LAST_ACTIVE_ACCOUNT_KEY, fromHandoff);
    } catch {
      // Storage unavailable
    }
    return fromHandoff;
  }
  try {
    return globalThis.sessionStorage.getItem(TAB_ACCOUNT_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function readLastActiveAccountId(): string | null {
  try {
    return globalThis.localStorage.getItem(LAST_ACTIVE_ACCOUNT_KEY);
  } catch {
    return null;
  }
}

export function writeTabAccountId(userId: string, options: { silent?: boolean } = {}): void {
  try {
    globalThis.sessionStorage.setItem(TAB_ACCOUNT_STORAGE_KEY, userId);
    globalThis.localStorage.setItem(LAST_ACTIVE_ACCOUNT_KEY, userId);
  } catch {
    // Storage unavailable
  }
  if (!options.silent) {
    notifyTabAccountChanged();
  }
}

export function clearTabAccountId(): void {
  try {
    globalThis.sessionStorage.removeItem(TAB_ACCOUNT_STORAGE_KEY);
  } catch {
    // Storage unavailable
  }
  notifyTabAccountChanged();
}

export function notifyTabAccountChanged(): void {
  if (typeof globalThis.dispatchEvent === "function") {
    globalThis.dispatchEvent(new CustomEvent(TAB_ACCOUNT_CHANGED_EVENT));
  }
}

const [reactiveTabAccountId, setReactiveTabAccountId] = createSignal<string | null>(
  readTabAccountId(),
);

if (typeof globalThis.addEventListener === "function") {
  globalThis.addEventListener(TAB_ACCOUNT_CHANGED_EVENT, () => {
    setReactiveTabAccountId(readTabAccountId());
  });
}

export function activeTabAccountId(): string | null {
  return reactiveTabAccountId();
}
